import type { Periodo } from './periodo';

/**
 * As abas de período dos cards de produção — o trilho cinza com a pastilha
 * branca, o mesmo controle que já existia no canto do gráfico grande.
 *
 * Vive fora dos cards porque agora são DOIS cards mostrando o mesmo controle,
 * e a escolha é uma só: o estado mora no HomeDashboard e clicar aqui troca os
 * dois ao mesmo tempo. Duas cópias do botão dariam duas verdades na mesma
 * tela.
 */

const OPCOES: [Periodo, string][] = [
  ['mes', 'Mês'],
  ['semestre', 'Semestre'],
  ['ano', 'Ano'],
];

export const SeletorPeriodo = ({
  valor,
  onChange,
  compacto = false,
}: {
  valor: Periodo;
  onChange: (periodo: Periodo) => void;
  /** Nos cards pequenos o trilho inteiro precisa caber ao lado do rótulo. */
  compacto?: boolean;
}) => (
  <div className="inline-flex shrink-0 rounded-[10px] bg-[rgba(53,70,96,0.08)] p-[3px] dark:bg-white/10">
    {OPCOES.map(([key, label]) => (
      <button
        key={key}
        type="button"
        aria-pressed={valor === key}
        onClick={() => onChange(key)}
        className={`cursor-pointer rounded-[7px] font-semibold ${
          compacto ? 'px-[7px] py-0.5 text-[10.5px]' : 'px-[11px] py-1 text-xs'
        } ${
          valor === key
            ? 'bg-card text-foreground shadow-[0_1px_2px_rgba(14,22,25,0.12)]'
            : 'text-[#6b7480] dark:text-muted-foreground'
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);
